import React, {Component} from 'react';
import {Col, Input, Pagination, Row, Select, Tag, Tooltip, Tree} from 'antd';

import {queryIncuAddressList} from '@api/incubator/address';

const { Search } = Input;
const { TreeNode } = Tree;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedKeys: this.props.addresses.map(item => item.uuid),
      tags: this.props.addresses,
      data: [],
      total: 0,
      page: 1,
    };
  }

  componentDidMount() {
    this.status = '0';
    this.getIncuAddressList();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.addresses.length !== nextProps.addresses.length) {
      this.setState({
        tags: nextProps.addresses,
      });
    }
  }

  getIncuAddressList = () => {
    queryIncuAddressList({
      incubatorUuid: this.props.incubatorUuid,
      condition: this.condition || '',
      start: this.page || 1,
      status: this.status,
    }).then(res => {
      if (res.statusCode === 200) {
        res.data.map(item => {
          const flag =
            item.status === 1 && this.props.addresses.every(item2 => item2.uuid !== item.uuid);
          if (flag) {
            item.disabled = true;
          } else {
            item.disabled = false;
          }

          return item;
        });
        this.setState({
          data: res.data,
          total: res.totalSize,
          page: this.page,
        });
      }
    });
  };

  handleClose = removedTag => {
    let { tags } = this.state;
    tags = tags.filter(tag => tag.key !== removedTag);
    let { checkedKeys } = this.state;
    checkedKeys = checkedKeys.filter(item => item !== removedTag);
    this.props.handleChange(checkedKeys, tags);
    this.setState({ tags, checkedKeys });
  };

  handleSelect = (key, e) => {
    const { eventKey } = e.node.props;
    let { tags, checkedKeys } = this.state;
    if (tags.every(item => item.uuid !== eventKey)) {
      tags.push({
        name: e.node.props.title,
        uuid: eventKey,
      });
      checkedKeys.push(eventKey);
    } else {
      tags = tags.filter(item => item.uuid !== eventKey);
      checkedKeys = checkedKeys.filter(item => item !== eventKey);
    }
    this.props.handleChange(checkedKeys, tags);
    this.setState({ tags, checkedKeys });
  };

  onSearch = e => {
    this.condition = e.target.value;
    this.page = 1;
    this.getIncuAddressList();
  };

  onSelect = value => {
    this.status = value;
    this.page = 1;
    this.getIncuAddressList();
  };

  handlePageChange = page => {
    this.page = page;
    this.getIncuAddressList();
  };

  saveInputRef = input => {
    this.input = input;
  };

  render() {
    const { tags, data, checkedKeys, total, page } = this.state;
    return (
      <div>
        <div
          style={{
            marginBottom: '16px',
            borderRadius: '5px',
            padding: '10px',
            border: '1px solid #ddd',
          }}
        >
          {tags.map((item, index) => {
            const isLongTag = item.name.length > 20;
            const tagElem = (
              <Tag key={item.uuid} closable onClose={() => this.handleClose(item.uuid)}>
                {isLongTag ? `${item.name.slice(0, 20)}...` : item.name}
              </Tag>
            );
            return isLongTag ? (
              <Tooltip title={item.name} key={item.uuid}>
                {tagElem}
              </Tooltip>
            ) : (
              tagElem
            );
          })}
        </div>
        <Row>
          <Col span="11">
            <Select onChange={this.onSelect} defaultValue="0" style={{ width: '100%' }}>
              <Select.Option key="0" value="0">
                未使用
              </Select.Option>
              <Select.Option key="1" value="1">
                已使用
              </Select.Option>
              <Select.Option key="2" value="2">
                审核中
              </Select.Option>
            </Select>
          </Col>
          <Col span="1" />
          <Col span="12">
            <Search style={{ marginBottom: 8 }} placeholder="Search" onChange={this.onSearch} />
          </Col>
        </Row>

        <Tree onCheck={this.handleSelect} checkable checkedKeys={checkedKeys}>
          {data.map(item => (
            <TreeNode title={item.name} key={item.uuid} disabled={item.disabled} />
          ))}
        </Tree>
        <Pagination
          current={page}
          total={total}
          defaultPageSize={15}
          onChange={this.handlePageChange}
        />
      </div>
    );
  }
}

export default BaseForm;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/comm/ComAddressSelect.js